import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { PayService } from 'src/app/service/pay.service';
import 'datatables.net';
import 'datatables.net-dt';
import $ from 'jquery';
import { UserSessionService } from 'src/app/user-session.service';
import { ConnectedUser } from '../../shared/connected-user';

@Component({
  selector: 'app-partner-dashboard',
  templateUrl: './partner-dashboard.component.html',
  styleUrls: ['./partner-dashboard.component.css'],
  standalone: false
})
export class PartnerDashboardComponent implements OnInit {
  username: string;
  soldeGenerale: any;
  totalclickPay: any;
  totalmonthpay: any;
  accountNumber: any;
  paiementList: any[];
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  factureList: any[];
  transfert: boolean;
  notTranfering: boolean;
  pay: boolean;
  accountId: any;
  taxelist: any;

  withdrawAccountNumber = '';
  generatedWithdrawCode: number;
  withdrawCodeError: string;
  generatingWithdrawCode = false;
  user: ConnectedUser | null = null;

  constructor(private userService: PayService, private router: Router, private userSessionService: UserSessionService) { }

  ngOnInit(): void {
    this.getallFactureBaccount();
    $('#paiement').DataTable().init;
    this.user = this.userSessionService.getUser();
    this.username = this.userSessionService.getUser()?.username || '';
    this.getAccountPartner();
    this.findAllPaiementTransaction();
  }

  getAccountPartner() {
    this.userService.getPartenairebAccount(this.user.username).subscribe({
      next: (data) => {
        this.accountId = data['id'];
        this.soldeGenerale = data['accountBalance'];
        this.totalclickPay = data['totalclickPay'];
        this.totalmonthpay = data['totalmonthpay'];
        this.accountNumber = data['accountNumber'];
        if (!this.withdrawAccountNumber && this.accountNumber) {
          this.withdrawAccountNumber = String(this.accountNumber);
        }
      },
      error: () => {
        // Certaines vues (ex: SPAY_OPERATOR) n'exposent pas ce endpoint partenaire.
      }
    });
  }

  getMensualiteAndTaxesList() {
    this.userService.getMensualiteAndTaxesList(this.accountId).subscribe((data: any) => {
      this.taxelist = data;
      console.log(this.taxelist);
    });
  }

  findAllPaiementTransaction() {
    $('#paiement').DataTable().destroy();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true
    };

    this.userService.getallPaiementTransaction().subscribe({
      next: (data: any[]) => {
        this.paiementList = data;
        this.dtTrigger.next();
      },
      error: () => {
        // Certaines vues (ex: SPAY_OPERATOR) n'exposent pas ce endpoint partenaire.
      }
    });
  }

  getallFactureBaccount() {
    this.userService.getFacturesBaccount().subscribe({
      next: (data: any[]) => {
        this.factureList = data;
      },
      error: () => {
        // Certaines vues (ex: SPAY_OPERATOR) n'exposent pas ce endpoint partenaire.
      }
    });
  }

  generateBusinessWithdrawCode() {
    const accountNumber = (this.withdrawAccountNumber || this.accountNumber || '').toString().trim();
    this.generatedWithdrawCode = undefined;
    this.withdrawCodeError = undefined;

    if (!accountNumber) {
      this.withdrawCodeError = 'Saisir un numéro de compte business';
      return;
    }

    this.generatingWithdrawCode = true;
    this.userService.getPinretraitBussness(accountNumber).subscribe({
      next: (code: any) => {
        const numericCode = Number(code);
        this.generatedWithdrawCode = Number.isNaN(numericCode) ? code : numericCode;
        this.withdrawAccountNumber = accountNumber;
        this.generatingWithdrawCode = false;
      },
      error: (err) => {
        this.withdrawCodeError = err?.error?.message || 'Impossible de générer le code de retrait';
        this.generatingWithdrawCode = false;
      }
    });
  }

  getBaccount(source) {
    // alert("afficher les informations sur ce compte===cette methode doit etre implémenté")
  }

  makeTransfert(id, accountNumber) {
    this.userService.transfertMensualiteForce(id, accountNumber).subscribe(data => {
      if (data == 0) {
        this.transfert = true;
        setTimeout(() => {
          this.transfert = false;
          this.getallFactureBaccount();
        }, 3000);
      }
      else if (data == -1) {
        this.notTranfering = true;
        setTimeout(() => {
          this.notTranfering = false;
        }, 3000);
      }
      else {
        /*this.pay = true;
        setTimeout(() => {
          this.pay = false;
        }, 3000);*/
      }
    });
  }

}
